export function getPluginDrawerSheetKey(pluginId: string) {
  return `plugin-drawer:${pluginId}`;
}
